import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { StudentPanelsModule } from '../../common-panels/student-panels.module';
import { ProfileCollapsePanelsWidgetModule } from '../widgets/profile-collapse-panels-widget/profile-collapse-panels-widget.module';
import { SsvSelectPanelsWidgetModule } from '../widgets/ssv-select-panels-widget/ssv-select-panels-widget.module';
import { SharedServicesModule } from './../../../shared/services/shared.services.module';
import { SsvSideNavSecondary } from './ssv-side-nav-secondary.component';

@NgModule({
  declarations: [SsvSideNavSecondary],
  imports: [
    CommonModule,
    SharedServicesModule,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatCheckboxModule,
    SsvSelectPanelsWidgetModule,
    ProfileCollapsePanelsWidgetModule,
    FormsModule,
    StudentPanelsModule,
  ],
  exports: [SsvSideNavSecondary],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SsvSideNavSecondaryModule {}
